var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-intro" }, [
    _c("img", { staticClass: "bg", attrs: { src: _vm.bgImg } }),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contents" }, [
      _c("div", { staticClass: "p1" }, [
        _c("div", { staticClass: "p2" }, [
          _c("p", { staticClass: "text1" }, [
            _c("span", { staticClass: "t1" }, [
              _vm._v("새로운 자동차 관리의 시작")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("span", { staticClass: "t2" }, [
              _vm._v("내 손안의 차량관리 ‘"),
              _c("span", [_vm._v("카랑")]),
              _vm._v("’")
            ]),
            _vm._v(" "),
            _c("br")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text2" }, [
            _vm._v("\n\t\t\t\t\tVISITION & CULTURE"),
            _c("br"),
            _vm._v("\n\t\t\t\t\t자동차 애프터마켓 플랫폼"),
            _c("br")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5258b9cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5258b9cb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/intro/MainIntro.vue
// module id = null
// module chunks = 